import {GESTION_OPERATIVA_CLEANURL_PAYMENT} from '../constants'

export function reducer(state, action) {
    
    if (action.type === GESTION_OPERATIVA_CLEANURL_PAYMENT){
        return {...state, urlAddPayment: false}
    } else {
        return state
    }     
    
}